# Action types
export SET_CLIPBOARD_DATA            = 'SET_CLIPBOARD_DATA'
export CLEAR_EDITS                   = 'CLEAR_EDITS'
export SET_COLUMNS                   = 'SET_COLUMNS'
export SET_COLUMN_WIDTHS             = 'SET_COLUMN_WIDTHS'
export SET_CONTEXT_MENU_EVENT        = 'SET_CONTEXT_MENU_EVENT'
export SET_COUNT                     = 'SET_COUNT'
export SET_CURRENT_COUNT             = 'SET_CURRENT_COUNT'
export SET_CURRENT_HIGHEST_REQUESTED = 'SET_CURRENT_HIGHEST_REQUESTED'
export SET_EDITS                     = 'SET_EDITS'
export SET_FILTERS                   = 'SET_FILTERS'
export SET_IS_DRAGGING               = 'SET_IS_DRAGGING'
export SET_IS_ESCAPING_EDIT_MODE     = 'SET_IS_ESCAPING_EDIT_MODE'
export SET_IS_FETCHING               = 'SET_IS_FETCHING'
export SET_IS_IN_EDIT_MODE           = 'SET_IS_IN_EDIT_MODE'
export SET_LOADING                   = 'SET_LOADING'
export SET_NODE_ORDER                = 'SET_NODE_ORDER'
export SET_REDOS                     = 'SET_REDOS'
export SET_RESIZED_COLUMN_WIDTHS     = 'SET_RESIZED_COLUMN_WIDTHS'
export SET_ROWS_TO_BE_DELETED        = 'SET_ROWS_TO_BE_DELETED'
export SET_RELATIONS_MAP             = 'SET_RELATIONS_MAP'
export SET_ROW_HEADERS               = 'SET_ROW_HEADERS'
export SET_SELECTION                 = 'SET_SELECTION'
export SET_SELECTION_TYPE            = 'SET_SELECTION_TYPE'
export SET_SORTER                    = 'SET_SORTER'
export SET_UNDOS                     = 'SET_UNDOS'
